<template>
  <template v-if="showFullName">
    <base-form-input
      :errors="errors ? errors.name : null"
      :value="address ? address.name : ''"
      :attribute="attribute"
      label="Name"
      name="name"
      @update:data="$emit('update:data', $event)"
    ></base-form-input>
  </template>
  <template v-else>
    <div class="row g-3">
      <div :class="showUid ? 'col-8' : 'col-12'">
        <base-form-input
          :errors="errors ? errors.company : null"
          :value="address ? address.company : ''"
          :attribute="attribute"
          label="Firma"
          name="company"
          @update:data="$emit('update:data', $event)"
        ></base-form-input>
      </div>
      <div v-if="showUid" class="col-4">
        <base-form-input
          :errors="errors ? errors.uid : null"
          :value="address ? address.uid : ''"
          :attribute="attribute"
          label="UID-Nummer"
          name="uid"
          @update:data="$emit('update:data', $event)"
        ></base-form-input>
      </div>
    </div>
    <hr v-if="showUid" class="mt-0" />
    <div class="row g-3">
      <div class="col-6">
        <base-form-input
          :errors="errors ? errors.first_name : null"
          :value="address ? address.first_name : ''"
          :attribute="attribute"
          label="Vorname"
          name="first_name"
          @update:data="$emit('update:data', $event)"
        ></base-form-input>
      </div>
      <div class="col-6">
        <base-form-input
          :errors="errors ? errors.last_name : null"
          :value="address ? address.last_name : ''"
          :attribute="attribute"
          label="Nachname"
          name="last_name"
          @update:data="$emit('update:data', $event)"
        ></base-form-input>
      </div>
    </div>
    <hr class="mt-0" />
  </template>

  <div class="row g-3">
    <div :class="supplementalInOwnRow ? 'col-9' : 'col-6'">
      <base-form-input
        :errors="errors ? errors.street : null"
        :value="address ? address.street : ''"
        :attribute="attribute"
        label="Straße"
        name="street"
        :required="true"
        @update:data="$emit('update:data', $event)"
      ></base-form-input>
    </div>
    <div class="col-3">
      <base-form-input
        :errors="errors ? errors.house_number : null"
        :value="address ? address.house_number : ''"
        :attribute="attribute"
        label="Hausnummer"
        name="house_number"
        :required="true"
        @update:data="$emit('update:data', $event)"
      ></base-form-input>
    </div>
    <div :class="supplementalInOwnRow ? 'col-12 mt-0' : 'col-3'">
      <base-form-input
        :errors="errors ? errors.address_supplement : null"
        :value="address ? address.address_supplement : ''"
        :attribute="attribute"
        label="Adresszusatz"
        name="address_supplement"
        @update:data="$emit('update:data', $event)"
      ></base-form-input>
    </div>
  </div>
  <div class="row g-3">
    <div :class="hideCountry ? 'col-4' : 'col-4 col-lg-2'">
      <base-form-input
        :errors="errors ? errors.postal_code : null"
        :value="address ? address.postal_code : ''"
        :attribute="attribute"
        label="PLZ"
        name="postal_code"
        :required="true"
        @update:data="$emit('update:data', $event)"
      ></base-form-input>
    </div>
    <div :class="hideCountry ? 'col-8' : 'col-8 col-lg-5'">
      <base-form-input
        :errors="errors ? errors.city : null"
        :value="address ? address.city : ''"
        :attribute="attribute"
        label="Ort"
        name="city"
        :required="true"
        @update:data="$emit('update:data', $event)"
      ></base-form-input>
    </div>
    <div v-if="!hideCountry" class="col-12 mt-0 mt-lg-3 col-lg-5">
      <base-form-input
        type="text"
        label="Land"
        :readonly="true"
        value="Österreich"
        name="country"
        :required="true"
      ></base-form-input>
    </div>
  </div>
  <hr v-if="showPhone" class="mt-0" />
  <div v-if="showPhone" class="input-group mb-3">
    <span class="input-group-text fs-4 text-primary d-flex justify-content-center"
      ><i class="bi bi-telephone"></i
    ></span>
    <base-form-input
      :errors="errors ? errors.phone : null"
      :value="address ? address.phone : ''"
      :attribute="attribute"
      label="Telefonnummer"
      name="phone"
      type="phone"
      :required="true"
      @update:data="$emit('update:data', $event)"
    ></base-form-input>
  </div>
</template>

<script>
import BaseFormInput from './BaseFormInput';
export default {
  components: { BaseFormInput },
  props: {
    address: {
      type: Object,
      default: () => {},
    },
    attribute: {
      type: String,
      default: 'contact',
    },
    errors: {
      type: Object,
      default: null,
    },
    hideCountry: {
      type: Boolean,
      default: false,
    },
    showFullName: {
      type: Boolean,
      default: false,
    },
    showPhone: {
      type: Boolean,
      default: false,
    },
    showUid: {
      type: Boolean,
      default: false,
    },
    supplementalInOwnRow: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:data'],
  setup() {
    const selectOptions = [
      {
        text: '--- Bitte ein Land auswählen ---',
        value: '0',
      },
      { text: 'Österreich', value: 'Österreich' },
      { text: 'Deutschland', value: 'Deutschland' },
      { text: 'Schweiz', value: 'Schweiz' },
    ];

    return {
      selectOptions,
    };
  },
};
</script>
